import { buildPathTranslations } from './paths'

export default buildPathTranslations(file => require(`../paths/${file}`))
